export default {
  data(){
    return{
      formData:{},
      roomNumReg:/^[a-zA-Z0-9]*$/,
      nameInvalidReg:/^[\w\W]*([A-Za-z]|[\u4E00-\u9FA5])[\w\W]*$/,
      mobileNumReg: /^1\d{10}$/, //手机号
      normalNumReg: /^[1-9]\d*$/, //大于0的数字校验
      socialCreditCodeReg: /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/, //社会信用代码
      EmailReg: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, //邮箱
      qqNumReg: /^[1-9][0-9]{4,10}$/, //QQ号
      legalCharactersReg: /^[a-zA-Z0-9\u4e00-\u9fa5_]*$/, //合法字符
      macNumReg: /^([0-9a-fA-F]{2})(([/\s:-][0-9a-fA-F]{2}){5})$/, //mac地址
      imeiNumReg: /^\d{14,15}$/, //IMEI
      imsiNumReg: /^\d{14,15}$/, //IMSI
      cardIdReg: /^(([\u4e00-\u9fa5][a-zA-Z]|[\u4e00-\u9fa5]{2}\d{2}|[\u4e00-\u9fa5]{2}[a-zA-Z])[-]?|([wW][Jj][\u4e00-\u9fa5]{1}[-]?)|([a-zA-Z]{2}))([A-Za-z0-9]{5}|[DdFf][A-HJ-NP-Za-hj-np-z0-9][0-9]{4}|[0-9]{5}[DdFf])$/, //车牌号
      websiteReg: /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/|www\.)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/, //网址格式
      weChartReg: /^[1-9][0-9]{4,10}$/, //微信
      ipAddressReg: /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/, //ip地址
    }
  },
  methods: {
    //rules:大陆二代身份证号码校验
    checkIDCardCode(rule, value, callback){
      if ((value) && (!this.checkCNID(value))) {
        callback(new Error('请输入正确的身份证号！'));
      }else {
        callback();
      }
    },
    //rules:大于0数字校验
    validateNum(rule, value, callback){
      if(value===''){
        callback();
      }
      else if ( !this.normalNumReg.test(value)) {
        callback(new Error('请输入正确的数字值！'));
      }else {
        callback();
      }
    },
    //rules:手机号码校验
    checkTel(rule, value, callback){
      if ((value)  && !this.checkTelNum(value)) {
        callback(new Error('请输入正确的手机号！'));
      } else {
        callback();
      }
    },
    //rules:网址校验
    validateWebsite(rule, value, callback){
      if ((value)  && !this.checkWebsite(value)) {
        callback(new Error('请输入正确的网址！'));
      } else {
        callback();
      }
    },
    //rules:社会信用代码校验
    checkSocialCode(rule, value, callback){
      if ((value)  && !this.checkSocialCreditCode(value)) {
        callback(new Error('请输入正确的社会信用代码！'));
      } else {
        callback();
      }
    },
    //rules:MAC地址校验
    checkMAC(rule, value, callback){
      if ((value)  && (!this.checkMACNum(value))) {
        callback(new Error('请输入正确的MAC地址！'));
      } else {
        callback();
      }
    },
    //rules:IMEI校验
    checkIMEI(rule, value, callback){
      if ((value)  && (!this.checkIMEINum(value))) {
        callback(new Error('请输入正确的IMEI！'));
      } else {
        callback();
      }
    },
    //rules:IMSI校验
    checkIMSI(rule, value, callback){
      if ((value)  && (!this.checkIMSINum(value))) {
        callback(new Error('请输入正确的IMSI！'));
      } else {
        callback();
      }
    },
    //rules:车牌号校验
    checkCarNum(rule, value, callback){
      if ((value)  && (!this.checkCarID(value))) {
        callback(new Error('请输入正确的车牌号！'));
      } else {
        callback();
      }
    },
    // //rules:QQ校验
    checkQQ(rule, value, callback){
      if ((value)  && (!this.checkQQNum(value))) {
        callback(new Error('请输入正确的QQ号！'));
      } else {
        callback();
      }
    },
    //rules:微信校验
    checkWX(rule, value, callback){
      if ((value)  && (!this.checkWeChart(value))) {
        callback(new Error('请输入正确的微信号！'));
      } else {
        callback();
      }
    },
    //rules:姓名校验
    checkName(rule, value, callback){
      let ruleData = /([\u4e00-\u9fa5]{2,4})/;
      if ((value)  && (!ruleData.test(value))) {
        callback(new Error('请输入正确的2到4位字符！'));
      } else {
        callback();
      }
    },
    //大陆二代身份证号码校验
    checkCNID(cid){
      if(cid.length===18){
        let arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];//加权因子
        let arrValid = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];//校验码
        let reg = /[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]/i;
        if(reg.test(cid)){
          /*let sum = 0, idx;
          for(let i = 0; i < cid.length-1; i++){
            sum += parseInt(cid.substr(i, 1), 10) * arrExp[i];
          }
          idx = sum % 11;
          return arrValid[idx] == cid.substr(17, 1).toUpperCase();*/
          return true
        }else{
          return false;
        }
      }else if(cid.length === 15){//大陆一代身份证号码15位校验
        let regi = /[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}/;
        return regi.test(cid) ? true : false
      }else{
        return false;
      }
    },
    //公用校验方法
    handleCommonCheck(val, reg, result = false){
      if(val && val.trim()){
        if(val.indexOf(',') > -1){
          let errStatus = false
          let arr = val.split(',')
          arr.forEach(item =>{
            if(!item){
              errStatus = true
            }else if(item && !reg.test(item)){
              errStatus = true
            }
          })
          result = !errStatus
        }else{
          result = reg.test(val) ? true : false
        }
      }
      return result
    },
    //名称校验
    checkCommonName(val){
      return this.handleCommonCheck(val, this.nameInvalidReg)
    },
    //手机号校验
    checkTelNum(val){
      return this.handleCommonCheck(val, this.mobileNumReg)
    },
    //房间号校验
    checkRoomNum(val){
      return this.handleCommonCheck(val, this.roomNumReg)
    },
    //社会信用代码校验
    checkSocialCreditCode(val){
      return this.handleCommonCheck(val, this.socialCreditCodeReg)
    },
    //邮箱校验
    checkEMail(val){
      return this.handleCommonCheck(val, this.EmailReg)
    },
    //QQ校验
    checkQQNum(val){
      return this.handleCommonCheck(val, this.qqNumReg)
    },
    //非法字符校验
    checkIllegalCharacters(val){
      return this.handleCommonCheck(val, this.legalCharactersReg)
    },
    //MAC校验
    checkMACNum(val){
      return this.handleCommonCheck(val, this.macNumReg)
    },
    //IMEI校验
    checkIMEINum(val){
      return this.handleCommonCheck(val, this.imeiNumReg)
    },
    //IMSI校验
    checkIMSINum(val){
      return this.handleCommonCheck(val, this.imsiNumReg)
    },
    //车牌校验
    checkCarID(val){
      return this.handleCommonCheck(val, this.cardIdReg)
    },
    //网址格式校验
    checkWebsite(val){
      return this.handleCommonCheck(val, this.websiteReg)
    },
    //微信校验
    checkWeChart(val){
      return this.handleCommonCheck(val, this.weChartReg)
    },
    //IP地址校验
    checkIPAddress(val){
      return this.handleCommonCheck(val, this.ipAddressReg)
    },
    //端口校验
    checkPort(rule, value, callback){
      if (value<0 || value>65535) {
        callback(new Error('端口范围：0~65535'));
      } else {
        callback();
      }
    },
    //对象中的数据执行trim操作
    trimFormData(){
      for(let name in this.formData) {
        if(typeof this.formData[name] === 'string'){
          this.formData[name] = this.formData[name].trim()
        }
      }
    }
  }
}
